import React from 'react';
import { Intent } from 'constants/ui';
import { isItemStatusExternallyPaid } from 'helpers/items';
import { getVendorOrCustomerTitleFromItemKind } from 'helpers/partnerships';
import BaseHint from '../BaseHint';
const SelectPaymentMethodHint = ({ item, partnerFundingAccount, partnership }) => {
    if (partnerFundingAccount || isItemStatusExternallyPaid(item) || !partnership) {
        return null;
    }
    const vendorOrCustomer = getVendorOrCustomerTitleFromItemKind(item.kind);
    return (React.createElement(BaseHint, { dataFullStoryTitle: true, intent: Intent.WARNING, multiline: true, text: `Your ${vendorOrCustomer} is able to select and add their payment method information when accepting this payment.`, title: `Waiting for ${partnership.name} to select a payment method` }));
};
export default SelectPaymentMethodHint;
